import { mixin } from 'cssapi'
import { css } from 'styled-components'

const underlineOverlineHover = api => color => css`
  position: relative;

  ::after {
    content: '';
    transition: all 0.1s ease-in-out;
    z-index: -1;
    position: absolute;
    left: 0;
    right: 0;
    top: 10%;
    bottom: 10%;
    opacity: 0;

    ${api({
      borderV: `transparent solid 3px`,
    })};
  }

  &.isActive::after,
  html.feat-no-touchevents &:hover::after {
    top: -4%;
    bottom: 0;
    transition: color 0.1s, top 0.1s, bottom 0.1s;
    transition-timing-function: ease-in-out;
    opacity: 1;

    ${api({
      borderTopColor: color,
      borderBottomColor: color,
    })};
  }
`
export default mixin(underlineOverlineHover)



// WEBPACK FOOTER //
// ./src/components/styles/mixins/underlineOverlineHover.js